module.exports = __webpack_public_path__ + "img/128ne.9b0f60c4.svg";